<template>
  <navigation-layout ref='navigationlayout'>
    <h1 slot="title">{{title}}</h1>
    <h3 slot="abstract">{{abstract}}</h3>
    <main v-if="endLoading">
      <md-tabs class="md-transparent" md-alignment="fixed">
        <md-tab id="tab-chain-info" md-label="Chain Info">
          <chain-info :parentref='this'/>
        </md-tab>
        <md-tab id="tab-facilities" md-label="Facilities">
          <chain-facilities :parentref='this'/>
        </md-tab>
        <md-tab id="tab-staff" md-label="Staff">
          <chain-staff :parentref='this' />
        </md-tab>
        <md-tab id="tab-integration-info" md-label="Integration info">
          <chain-integration-info :parentref='this'/>
        </md-tab>
      </md-tabs>
    </main>
  </navigation-layout>
</template>

<script>
import ChainInfo from '@/components/views/chain/chain-info'
import ChainIntegrationInfo from '@/components/views/chain/chain-integration-info'
import ChainStaff from '@/components/views/chain/chain-staff'
import ChainFacilities from '@/components/views/chain/chain-facilities'
import NavigationLayout from '@/components/layouts/navigation'
import RepositoryService from '@/services/repositoryService'
import router from '@/router'

export default {
  name: 'chain-menu',
  data: () => ({
    title: '',
    abstract: 'Manage a chain',
    endLoading: false
  }),
  created: async function () {
    if (!RepositoryService.session.selectedFacility || (!RepositoryService.session.selectedFacility.isChain &&
            !RepositoryService.session.selectedFacility.chainFacilityId)) {
      router.push({
        name: 'searchchain'
      })
    } else if (RepositoryService.session.selectedFacility.chainFacilityId) {
      var detailsResponse = await RepositoryService.chainDetails(RepositoryService.session.selectedFacility.chainFacilityId)
      RepositoryService.session.setselectedChain(detailsResponse.data)
    }
    this.endLoading = true
    this.$route.meta.breadcrumb = [{
      name: RepositoryService.session.selectedBillingCompany.companyName,
      link: 'selectbillingcompany'
    },
    {
      name: RepositoryService.session.selectedFacility.name
    }
    ]
    this.title = RepositoryService.session.selectedFacility.name
  },
  components: {
    ChainInfo,
    ChainFacilities,
    ChainIntegrationInfo,
    ChainStaff,
    NavigationLayout
  }
}

</script>
